
import {Options, Vue} from "vue-class-component";
import {Speaker} from "@/entities/Speaker";
import {Speech} from "@/entities/Speech";
import {Prop} from "vue-property-decorator";
import {isDefined} from "@/utils";


@Options({})
export default class SpeakerDetailDialog extends Vue {


  private speeches: Speech[];
  private speaker: Speaker;
  private isOpen: boolean = false;
  @Prop(Function) getLangForSpeech: (id) => string;

  constructor(props) {
    super(props);
  }

  public openDialog(speaker: Speaker, speeches: Speech[]): void {
    this.addClickListener();
    this.speeches = speeches;
    this.speaker = speaker;
    this.isOpen = true;
  }


  private onClick(event) {
    if (isDefined(this.$refs.container) && this.isOpen) {
      const container = this.$refs.container as any;
      if (isDefined(container)) {
        if (!container.contains(event.target)) {
          this.closeDialog();
        }
      }
    }
  }

  private addClickListener() {
    window.addEventListener('click', this.onClick);
  }

  private removeClickListener() {
    window.removeEventListener('click', this.onClick);
  }

  public closeDialog(): void {
    this.removeClickListener();
    this.isOpen = false;
  }

  public getLangForSpeechById(id: string) {
    if (isDefined(this.getLangForSpeech)) {
      return this.getLangForSpeech(id);
    }
  }

  public getColorCSS(speech: Speech): string {
    return isDefined(speech.color) && speech.color.length === 6 ? ('background-color: #' + speech.color + ';color:' + speech.categoryColor) : '';
  }

  public getHeaderStyle(speech: Speech): string {
    return isDefined(speech.color) && speech.color.length === 6 ? (`border-bottom: 5px solid #${speech.color};`) : 'border-bottom: 5px solid var(--primary-color);'
  }

  public getIconStyle(speech: Speech): string {
    return speech.getIconStyle;
  }


}
